'use strict';

exports.__esModule = true;
exports.all = all;
exports.current = current;
exports.update = update;
exports.orderHistory = orderHistory;

var _http = require('../network/http');

var _quCheck = require('../utils/qu-check');

var API = {
  PARTNER_ORDERS: '/partner/orders',
  ORDER_HISTORY: '/partner/orders_history'

  /**
   * Wrapper for `/partner/order` API endpoint
   */

};var orders = {
  all: all,
  current: current,
  update: update,
  orderHistory: orderHistory
};

exports.default = orders;

/**
 * Get all orders
 * @returns {promise} containing the entity array of orders
 */

function all(page, perPage) {
  return (0, _http.get)(API.PARTNER_ORDERS, { page: page, per_page: perPage });
}

/**
 * Get all current orders
 * @returns {promise} containing the entity array of orders
 */
function current(page, perPage) {
  return (0, _http.get)(API.PARTNER_ORDERS, { current: true, page: page, per_page: perPage });
}

/**
 * Updates order using order id
 * @param {integer} orderId - order id
 * @param {integer} waitingMinutes (min)
 * @param {string} rejectionReason
 * @param {string} event - 'venue_transmit', 'venue_accept', 'venue_reject', 'start', 'placed', 'failed', 'ready'
 * @returns {promise} containing the updated order
 */
function update(orderId, waitingMinutes, rejectionReason, event) {
  _quCheck.checker.warn(_quCheck.common.event, event);

  return (0, _http.put)(API.PARTNER_ORDERS + '/' + orderId, { waitingMinutes: waitingMinutes, rejectionReason: rejectionReason, event: event });
}

function orderHistory(payload) {
  var start_date = payload.start_date,
      end_date = payload.end_date,
      locations = payload.locations;

  return (0, _http.get)(API.ORDER_HISTORY, { start_date: start_date, end_date: end_date, locations: locations });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@quiqupltd/quiqupjs/lib/partner/orders.js
// module id = 1065
// module chunks = 0